import {
  Box,
  Button,
  Flex,
  Heading,
  Spinner,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import TrailerCard from 'domains/trailer/components/TrailerCard';
import { useTranslation } from 'i18n/TranslationProvider';

const Trailers = ({
  loading,
  error,
  setSearchQuery,
  handleAdd,
  filteredTrailers,
  handleEdit,
  handleDelete,
  searchQuery,
}) => {
  const { t } = useTranslation();
  const sectionBg = useColorModeValue(
    'rgba(255, 255, 255, 0.55)',
    'rgba(13, 25, 58, 0.45)',
  );
  const sectionBorder = useColorModeValue(
    'rgba(255, 255, 255, 0.95)',
    'rgba(255, 255, 255, 0.14)',
  );
  const mutedText = useColorModeValue('gray.600', 'gray.300');
  const searchBg = useColorModeValue('white', 'whiteAlpha.120');

  return (
    <Box>
      <Flex
        mb={5}
        px={{ base: 3, md: 4 }}
        py={{ base: 3, md: 4 }}
        borderRadius="18px"
        bg={sectionBg}
        border="1px solid"
        borderColor={sectionBorder}
        backdropFilter="blur(8px)"
        direction={{ base: 'column', lg: 'row' }}
        align={{ base: 'stretch', lg: 'center' }}
        justify="space-between"
        gap={4}
      >
        <Stack spacing={1}>
          <Heading size="md">{t('Trailers')}</Heading>
          <Text fontSize={{ base: 'sm', md: 'md' }} color={mutedText}>
            {t('Manage trailer plate records and keep availability current.')}
          </Text>
        </Stack>

        <Flex
          gap={3}
          align="center"
          w={{ base: '100%', lg: 'auto' }}
          direction={{ base: 'column', md: 'row' }}
        >
          <SearchBar
            placeholder={t('Search trailers...')}
            onChange={(e) => setSearchQuery(e.target.value)}
            value={searchQuery}
            w={{ base: '100%', md: '280px' }}
            background={searchBg}
            borderRadius="14px"
          />
          <Button
            onClick={handleAdd}
            variant="brand"
            h="44px"
            px={6}
            w={{ base: '100%', md: 'auto' }}
            fontWeight="700"
          >
            {t('Add trailer')}
          </Button>
        </Flex>
      </Flex>

      {loading && (
        <Box
          borderRadius="16px"
          border="1px dashed"
          borderColor={sectionBorder}
          py={10}
          px={4}
          textAlign="center"
          bg={sectionBg}
        >
          <Spinner size="lg" />
          <Text mt={3} color={mutedText}>
            {t('Loading trailers...')}
          </Text>
        </Box>
      )}

      {error && (
        <Box
          borderRadius="16px"
          border="1px solid"
          borderColor="red.200"
          bg="red.50"
          px={4}
          py={3}
        >
          <Text color="red.600">{t('Error loading trailers')}</Text>
        </Box>
      )}

      {!loading && filteredTrailers.length === 0 && (
        <Box
          borderRadius="16px"
          border="1px dashed"
          borderColor={sectionBorder}
          py={10}
          px={4}
          textAlign="center"
          bg={sectionBg}
        >
          <Text color={mutedText} fontWeight="600">
            {searchQuery
              ? t('No trailers found for your search.')
              : t('No trailers found.')}
          </Text>
        </Box>
      )}

      <VStack spacing={3} align="stretch" mt={4}>
        {filteredTrailers.map((trailer) => (
          <TrailerCard
            key={trailer._id}
            trailer={trailer}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        ))}
      </VStack>
    </Box>
  );
};

export default Trailers;
